import React from 'react';
import styled from 'styled-components';

const msg = `해당 곡의 맛보기 강의를 
모두 수강하셨어요! 

이제부터 닥터뮤지와 
진짜 공부를 시작해볼까요?`;

const GoSellingPageWrap = styled.div`
  background-color: #fff;
  width: 250px;
  padding: 40px;
  border-radius: 15px;
  text-align: center;
  font-size: 13px;
  p {
    color: #333;
  }
`;

const GoSellingButton = styled.button`
  width: 100%;
  background-color: #312a75;
  color: #fff;
  border-radius: 15px;
  height: 35px;
  line-height: 35px;
  margin-top: 20px;
  font-size: 13px;
`;

function GoSellingPage({ goSellingPage }) {
  const message = msg.split('\n');

  return (
    <GoSellingPageWrap>
      <p dangerouslySetInnerHTML={{ __html: message.join('<br/>') }} />
      <GoSellingButton onClick={() => goSellingPage()}>좋아요!</GoSellingButton>
    </GoSellingPageWrap>
  );
}

export default GoSellingPage;
